export const lineStyle = { 
  data: { 
    stroke: '#4695c4', 
    strokeWidth: 2, 
    fill: 'url(#chartGradient)',
  }, 
  labels: { 
    fill: '#df6541', 
    fontSize: '16px',
  },
};

export const dotStyle = { 
  data: {
    fill: 'white',
    stroke: '#4695c4',
    strokeWidth: 1, 
    zIndex: 10,
  },
};

export const axisStyle = {
  ticks: { 
    stroke: 'grey', 
    size: 5,
  },
  axisLabel: { 
    fontSize: 10, 
    padding: 10,
  },
  tickLabels: { 
    fontSize: 16, 
    padding: 5,
  },
};

export const soldPricelineStyle = { 
  data: { 
    stroke: '#c6483a', 
    strokeWidth: 2,
  }, 
  labels: { 
    fill: '#df6541', 
    fontSize: '16px', 
  },
};

export const listPricelineStyle = { 
  data: { 
    stroke: '#4695c4', 
    strokeWidth: 2,
  }, 
  labels: { 
    fill: '#df6541', 
    fontSize: '16px',
  },
};

export const lineStyleExp = { 
  data: { 
    stroke: '#1B489B', 
    strokeWidth: 2, 
    fill: 'url(#chartGradient)',
  }, 
  labels: { 
    fill: '#6D071A', 
    fontSize: '16px',
  },
};

export const dotStyleExp = { 
  data: {
    fill: 'white',
    stroke: '#1B489B',
    strokeWidth: 1, 
    zIndex: 10,
  },
};

export const axisStyleExp = {
  ticks: { 
    stroke: 'grey', 
    size: 5,
  },
  axisLabel: { 
    fontSize: 10, 
    padding: 10,
  },
  tickLabels: { 
    fontSize: 16, 
    padding: 5,
  },
};

export const soldPricelineStyleExp = { 
  data: { 
    stroke: '#c6483a', 
    strokeWidth: 2,
  }, 
  labels: { 
    fill: '#6D071A', 
    fontSize: '16px', 
  },
};

export const listPricelineStyleExp = { 
  data: { 
    stroke: '#1B489B', 
    strokeWidth: 2,
  }, 
  labels: { 
    fill: '#6D071A', 
    fontSize: '16px',
  },
};
